import { isNil, sumBy } from 'lodash';
import numbro from 'numbro';

export const symbolForCurrency = (currencyByLocale) => {
  if (isNil(currencyByLocale)) {
    return '$'; // default return usd
  }
  switch (currencyByLocale.toLowerCase()) {
    // add locale codes to this switch statement
    case 'fr-fr':
    case 'de-de':
    case 'es-es':
    case 'it-it':
    case 'pt-pt':
    case 'nl-nl':
    case 'sv-se':
    case 'da-dk':
    case 'no-no':
    case 'fi-fi':
    case 'pl-pl':
    case 'ru-ru':
    case 'tr-tr':
    case 'uk-ua':
    case 'zh-cn':
    case 'zh-tw':
      return '€';
    case 'eur':
      return '€';
    case 'en-ca':
    case 'cad':
      return 'CA$';
    case 'en-gb':
    case 'en-au':
    case 'en-nz':
    case 'aud':
    case 'gbp':
      return 'GB£';
    case 'en-us':
    case 'usd':
      return '$';
    default: {
      // eslint-disable-next-line
      console.warn('Unknown currency:', currencyByLocale);
      return currencyByLocale ? currencyByLocale.toUpperCase() : currencyByLocale;
    }
  }
};

export const formatAmount = (amount, currencyByLocale, leaveZeroBlank) => {
  if (isNil(amount) || (leaveZeroBlank && amount && parseFloat(amount) === 0)) {
    return '';
  }
  const cultureData = numbro.cultureData();
  cultureData.currency.symbol = symbolForCurrency(currencyByLocale);
  const format = cultureData.formats ? cultureData.formats.fullWithTwoDecimals : '$ 0,0.00';
  return numbro(amount).format(format);
};

export const parseFloatSum = (counts = []) => sumBy(counts, (count) => parseFloat(count));
